import * as d3 from 'd3'
export default {
  methods: {

    dia_Router(selection) {

      let dia = this.winProps.idx ? this.db_Diagram.find(f=> f.IDX == this.winProps.idx) : {}

      let diaForm = selection
      .append('g')
      .attr('transform', `translate(0, 0)`)

      diaForm
      .append('text')
      .attr('x', 20).attr('y', 28).attr('fill', '#000') .attr('font-size', 17).attr('font-style', 'italic')
      .text('Diagram')

      diaForm
      .append('image')
      .attr('xlink:href', this.HOST + `/Database/img/PROJECT_${this.config.project}.png`)
      .attr('x', 30).attr('y', 50).attr('width', 167)

      this.gmx_Line(diaForm, 40, 860, 290, 290, '#E0E0DF', .5, 1)

      let getIdx = dia.IDX ? dia.IDX : Number(d3.max(this.db_Diagram, c => c.IDX)) + 1
      let getPhase = dia.PHASE ? dia.PHASE : this.winProps.phase
      let inputSet = [
        {id: 'IDX',     label: 'Index',        x: 500, y: 130, width: 50,  maxLen: 3,  value: getIdx,      type: 'fixed', },
        {id: 'SN',      label: 'Ordering',     x: 325, y: 130, width: 50,  maxLen: 3,  value: dia.SN,      type: 'number',  lColor: '#EC407A',},
        {id: 'PHASE',   label: 'Phase',        x: 55,  y: 130, width: 150, maxLen: 20, value: getPhase,    type: 'fixed', },
        {id: 'DIAGRAM', label: 'Diageam Name', x: 55,  y: 180, width: 250, maxLen: 35, value: dia.DIAGRAM,                  lColor: '#EC407A',},
        {id: 'DESCR',   label: 'Description',  x: 325, y: 180, width: 520, maxLen: 80, value: dia.DESCR,   },
        {id: 'MANAGER', label: 'Manager',      x: 55,  y: 230, width: 150, maxLen: 20, value: dia.MANAGER,                  lColor: '#EC407A',},
        {id: 'UPDATED', label: 'Updated Date', x: 500, y: 230, width: 150, maxLen: 10, value: dia.UPDATED ? dia.UPDATED.slice(0, 10) : '', type: 'fixed', },
      ]
      this.gmx_InputBox(diaForm, inputSet)
      this.gmx_Dropdown(diaForm, this.prequency, {id: 'PREQUENCY', label: 'Update Prequency', boxWidth: 100, x: 325, y: 230, verify: 'N'})



      let execution = selection
      .append('g')
      .attr('transform', `translate(20, 320)`)

      // CUTOFF -------------------------------------------------------------
      let calendar = execution
      .append('g')
      .attr('id', `CUTOFF`)
      .attr('transform', `translate(25, 0)`)

      calendar
      .append('image')
      .attr('xlink:href', this.HOST + `/Database/svg/Calender.svg`).attr('width', 60)

      inputSet = [
        {id: 'CTO_SCM',  label: 'Schema Name',   width: 150, x: 10, y: 140, maxLen: 18, value: dia.CTO_SCM,  },
        {id: 'CTO_TBL',  label: 'Table Name',    width: 150, x: 10, y: 190, maxLen: 18, value: dia.CTO_TBL,  },
        {id: 'CTO_CODE', label: 'Cutoff (Code)', width: 150, x: 10, y: 240, maxLen: 18, value: dia.CTO_CODE, },
        {id: 'CTO_DATE', label: 'Cutoff Date',   width: 120, x: 10, y: 290, maxLen: 10, value: dia.CTO_DATE ? dia.CTO_DATE.slice(0, 10) : '', type: 'date',},
      ]
      this.gmx_InputBox(calendar, inputSet)
      this.gmx_Dropdown(calendar, this.database, {id: 'CTO_DB', label: 'Database', value: dia.CTO_DB, boxWidth: 150, x: 10, y: 90, verify: 'N'})

      // VERIFY -------------------------------------------------------------
      let verify = execution
      .append('g')
      .attr('id', `VERIFY`)
      .attr('transform', `translate(240, 0)`)

      verify
      .append('image')
      .attr('xlink:href', this.HOST + `/Database/svg/Server_Verify.svg`).attr('width', 60)

      inputSet = [
        {id: 'VERIFY', label: 'Verify Model Name', width: 150, x: 10, y: 92, maxLen: 18, value: dia.VERIFY,},
      ]
      this.gmx_InputBox(verify, inputSet)


      // DEV SERVER -------------------------------------------------------------
      let dev = execution
      .append('g')
      .attr('id', `DEV`)
      .attr('transform', `translate(450, 0)`)

      dev
      .append('image')
      .attr('xlink:href', this.HOST + `/Database/svg/Server_Dev.svg`).attr('width', 60)

      
      inputSet = [
        {id: 'DEV_SCM', label: 'Schema Name',    width: 150, x: 10, y: 140, maxLen: 18, value: dia.DEV_SCM},
        {id: 'DEV_SP',  label: 'Procedure Name', width: 150, x: 10, y: 190, maxLen: 18, value: dia.DEV_SP},
      ]
      this.gmx_InputBox(dev, inputSet)
      this.gmx_Dropdown(dev, this.database, {id: 'DEV_DB', label: 'Database', value: dia.DEV_DB, boxWidth: 150, x: 10, y: 90, verify: 'N'})



      // SERVICE SERVER -------------------------------------------------------------
      let diagram = execution
      .append('g')
      .attr('id', `SERVICE`)
      .attr('transform', `translate(665, 0)`)

      diagram
      .append('image')
      .attr('xlink:href', this.HOST + `/Database/svg/Server_Service.svg`).attr('width', 60)

      inputSet = [
        {id: 'SVS_SCM', label: 'Schema Name',    width: 150, x: 10, y: 140, maxLen: 18, value: dia.SVS_SCM,},
        {id: 'SVS_SP',  label: 'Procedure Name', width: 150, x: 10, y: 190, maxLen: 18, value: dia.SVS_SP,},
      ]
      this.gmx_InputBox(diagram, inputSet)
      this.gmx_Dropdown(diagram, this.database, {id: 'SVS_DB', label: 'Database', value: dia.SVS_DB, boxWidth: 150, x: 10, y: 90, verify: 'N'})

      let buttons = selection
      .append('g')
      .attr('transform', `translate(${this.winProps.width-290}, ${this.winProps.height-50})`)

      buttons
      .append('image') // Save
      .attr('xlink:href', this.HOST + `/Database/btn/Save.svg`)
      .attr('x', this.winProps.mode == 'new' || this.winProps.mode == 'edit' ? 95 : 0).attr('y', 0).attr('width', 80).attr('cursor', 'pointer')
      .on('mouseover', function() {
        d3.select(this).transition().duration(75).style('opacity', .5)
      })
      .on('mouseout', function() {
        d3.select(this).transition().duration(250).style('opacity', 1)
      })
      .on('click', () => {
        this.verify_Diagram(selection) // -----> dia_Action.js
      })

      if(this.winProps.mode !== 'new' && this.winProps.mode !== 'edit') {

        buttons // DELETE
        .append('image') 
        .attr('xlink:href', this.HOST + `/Database/btn/Delete.svg`)
        .attr('x', 95).attr('y', 0).attr('width', 80).attr('cursor', 'pointer')
        .on('mouseover', function() {
          d3.select(this).transition().duration(75).style('opacity', .5)
        })
        .on('mouseout', function() {
          d3.select(this).transition().duration(250).style('opacity', 1)
        })
        .on('click', ()=> {

          let count = this.db_Table.filter(f=> f.IDX == dia.IDX).length
          if(count == 0) {
            let message = [
              {text: 'This action cannot be undone.'},
              {text: 'Related stage data will also be deleted.'},
              {text: 'Do you really want to delete?'}
            ]
            this.gmx_openPopup(selection, {type: 'Confirm', msg: message, func: this.del_Diagram, idx: getIdx,}) // -----> dia_Action.js
          } else {
            let message = [
              {text: 'Cannot delete!'},
              {text: 'Registered DB tables exist.'},
              {text: 'Delete them first and try again.'}
            ]
            this.gmx_openPopup(selection, {type: 'Alert', msg: message})
          }
          
        })
      }

      buttons
      .append('image') // Close
      .attr('xlink:href', this.HOST + `/Database/btn/Close.svg`)
      .attr('x', 190).attr('y', 0).attr('width', 80).attr('cursor', 'pointer')
      .call(this.call_WinClosed)
    },



    

  }
}